import http from '../../utils/fetch';
export default {
    //分页查询
    selectPage(query){
        return http({
            url: '/api/swyl/v1/grabOrderCustomer/selectPage',
            method: 'post',
            params: query
        });
    },
    //批量导出
    downloadBatchExcel(query) {
        return http({
            url: '/api/swyl/v1/grabOrderCustomer/downloadExcel',
            method: 'post',
            data: query,
            responseType: 'blob',
        });
    },

    //月度抢单客户导出详情
    downloadBatchExcelMonthOrder(query) {
        return http({
            url: '/api/swyl/v1/monthly/order/newDownloadExcel',
            method: 'post',
            data: query,
            responseType: 'blob',
        });
    },
    //获取动态表头信息
    getMonthList(query){
        return http({
            url: '/api/swyl/v1/quarterlyGrabOrder/selectMonthByQuarterly?quarterly='+query,
            method: 'post',
            params: query
        });
    },
    //批量删除
    deleteBatch(query){
        return http({
            url: '/api/swyl/v1/grabOrderCustomer/deleteBatch',
            method: 'post',
            data: query
        });
    },
    //查询区域经理
    selectUserName(query){
        return http({
            url: '/api/swyl/v1/grabOrderCustomer/selectUserList?userName='+ query,
            method: 'post',
            //data: query
        });
    },
    //查询单条
    selectById(query){
        return http({
            url: '/api/swyl/v1/grabOrderCustomer/selectById?id='+ query,
            method: 'post',
        });
    },

    ///api/swyl/v1/grabOrderCustomer/insertGrabOrder 
    saveGrabOrder(query){
        return http({
            url: '/api/swyl/v1/grabOrderCustomer/insertGrabOrder ',
            method: 'post',
            data: query
        });
    },
    //修改
    editGrabOrder(query){
        return http({
            url: '/api/swyl/v1/grabOrderCustomer/updateById',
            method: 'post',
            data: query
        });
    },
    //查询单条  ---------------非签约
    selectByIdGrabOrder(query){
        return http({
            url: '/api/swyl/v1/quarterlyGrabOrder/selectById?id='+ query,
            method: 'post',
        });
    },
    // 新增 ----非签约
    saveQuarterlyGrabOrder(query){
        return http({
            url: '/api/swyl/v1/quarterlyGrabOrder/saveQuarterlyGrabOrder ',
            method: 'post',
            data: query
        });
    },
    //修改 ----非签约
    updateQuarterlyGrabOrder(query){
        return http({
            url: '/api/swyl/v1/quarterlyGrabOrder/updateQuarterlyGrabOrder',
            method: 'post',
            data: query
        });
    },


}